module.exports = __webpack_public_path__ + "img/DG.03e99e05.svg";